import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Shuffle from 'react-shuffle';
import _ from 'lodash';

import {
  changeState,
  updateApp,
  updateQuiz,
  continueQuiz,
  createQuiz,
  updateDashboard,
  updateSettings
} from '../actions/index';
import { ASSET_PREFIX } from '../config/constants';

import CircularProgress from 'material-ui/CircularProgress';
import Slider from 'rc-slider';
import { Line } from 'rc-progress';
import 'rc-slider/assets/index.css';

import cross from '../images/X.svg';
import placeholder from '../images/EM-icon@3x.png';

import QbankButton from '../components/QbankButton';
import '../styles/Init.css';

const styles = {
  quizButton: {
    width: '280px',
    height: '50px'
  },
  nextButton: {
    width: '150px',
    height: '35px',
    fontSize: '13px'
  }
};

class Init extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mode: 'practice',
      count: this.props.params.questions
        ? this.props.params.questions.length
        : 5,
      tags: this.props.params.questions ? ['THIS IS A LAZY FIX'] : [],
      tabIndex:
        this.props.params &&
        (this.props.params.intro ||
          this.props.params.skip ||
          this.props.params.fromDash)
          ? 1
          : this.props.params.questions
          ? 2
          : 0,
      hippoSelect: true,
      exam: 'all',
      loading: false,
      organsAlpha: true,
      tagQuestionCount: this.props.params.questions
        ? this.props.params.questions.length
        : 0
    };

    this.componentMounted = true;

    this.toggleAllTags = this.toggleAllTags.bind(this);
    this.launchQuizFromDash = this.launchQuizFromDash.bind(this);
    this.handleContinue = this.handleContinue.bind(this);
    this.handleNew = this.handleNew.bind(this);
    this.handleNext = this.handleNext.bind(this);
    this.isOnFinalTab = this.isOnFinalTab.bind(this);
    this.onKeyDown = _.debounce(this.onKeyDown, 75, {
      leading: true,
      trailing: false
    }).bind(this);
  }

  componentWillMount() {
    document.addEventListener('keydown', this.onKeyDown, false);
  }

  componentWillUnmount() {
    this.props.updateQuiz({
      updateObject: { error: false }
    });
    document.removeEventListener('keydown', this.onKeyDown, false);
    this.componentMounted = false;
  }

  onKeyDown(e) {
    const { currentQuiz, isTrial } = this.props;
    const { count, loading, mode, tabIndex } = this.state;

    const swapMode = () =>
      this.setState({
        mode: this.state.mode === 'practice' ? 'test' : 'practice'
      });
    const swapSelect = () =>
      this.setState({ hippoSelect: !this.state.hippoSelect });

    const tabKeyToggles = {
      1: {
        ArrowRight: xl =>
          count <= (xl ? 290 : 295)
            ? this.setState({ count: count + (xl ? 10 : 5) })
            : null,
        ArrowLeft: xl =>
          count >= (xl ? 10 : 5)
            ? this.setState({ count: count - (xl ? 10 : 5) })
            : null
      },
      2: {
        ArrowRight: swapMode,
        ArrowLeft: swapMode
      },
      3: {
        ArrowRight: swapSelect,
        ArrowLeft: swapSelect
      }
    };

    const handleTabKey = (key, mod) => {
      tabKeyToggles[tabIndex]
        ? tabKeyToggles[tabIndex][key]
          ? tabKeyToggles[tabIndex][key](mod)
          : null
        : null;
    };

    if (!loading) {
      switch (e.key) {
        case 'Enter':
          isTrial
            ? this.initTrial()
            : e.shiftKey && currentQuiz
            ? this.handleContinue()
            : !this.isOnFinalTab()
            ? this.handleNext()
            : null;
          break;
        default:
          handleTabKey(e.key, e.shiftKey);
      }
    }
  }

  componentWillReceiveProps(next) {
    if (next.quiz && next.quiz.error) {
      this.setState({
        loading: false,
        error: true
      });
    } else if (
      ((!this.props.quiz && next.quiz) ||
        (this.props.quiz && !_.isEqual(this.props.quiz, next.quiz))) &&
      this.componentMounted
    ) {
      this.props.params.intro ? this.props.updateApp({ intro: false }) : null;
      this.props.changeState('quiz');
      this.props.updateDashboard(true);
    }
  }

  launchQuizFromDash() {
    this.props.createQuiz(
      this.props.params.fromDash,
      [],
      this.state.count,
      this.state.mode,
      false,
      null,
      true
    );
  }

  launchQuizFromHistory() {
    this.props.createQuiz(
      [],
      [],
      this.state.count,
      this.state.mode,
      false,
      this.props.params.questions,
      true
    );
  }

  sortTags(organsAlpha, tags) {
    return organsAlpha === false
      ? _.cloneDeep(tags).sort(
          (a, b) =>
            a.accountCorrectCount / a.accountTotalCount -
            b.accountCorrectCount / b.accountTotalCount
        )
      : tags;
  }

  initializeQuiz() {
    this.setState({
      loading: true
    });

    const examTags = this.state.exam === 'all' ? [] : [this.state.exam];
    const tags = this.sortTags(this.state.organsAlpha, this.props.tags);
    this.props.createQuiz(
      this.state.tags.map(i => tags[i].id),
      examTags,
      parseInt(this.state.count, 10),
      this.state.mode
    );
  }

  initTrial() {
    this.setState({
      loading: true
    });

    this.props.createQuiz([], [], 10, 'practice', true);
  }

  toggleAllTags() {
    this.setState({
      tags:
        this.state.tags.length < this.props.tags.length
          ? this.props.tags.map((o, i) => i)
          : [],
      tagQuestionCount:
        this.state.tags.length < this.props.tags.length
          ? this.props.tags.reduce((sum, tag) => tag.questionCount + sum, 0)
          : 0
    });
  }

  handleContinue() {
    this.setState({ loading: true });

    this.props.continueQuiz().then(() => this.props.changeState('quiz'));
  }

  handleNext() {
    const isPa = ASSET_PREFIX[this.props.product] == 'pa';
    if (this.state.tabIndex === 4 && this.state.hippoSelect) {
      this.initializeQuiz();
    } else {
      let tabIndex = this.state.tabIndex + 1;
      // skip PANCE/PANRE tab for EM and peds
      if (!isPa && this.state.tabIndex == 2) {
        tabIndex++;
      }
      this.setState(
        Object.assign(
          { tabIndex },
          this.state.tabIndex === 1 && this.state.count === ''
            ? { count: 5 }
            : {}
        )
      );
    }
  }

  handleNew() {
    this.setState({ loading: true });
    this.props.params.fromDash
      ? this.launchQuizFromDash()
      : this.props.params.questions
      ? this.launchQuizFromHistory()
      : this.initializeQuiz();
  }

  isOnFinalTab() {
    return (
      this.state.tabIndex === 5 ||
      (this.props.params.fromDash && this.state.tabIndex === 3) ||
      (this.props.params.questions && this.state.tabIndex === 2)
    );
  }

  generateTab(icon, title, subtitle, body, classname) {
    const { quiz } = this.props;
    const { error } = quiz ? quiz : {};
    return (
      <div className={classname ? classname : ''}>
        {icon ? (
          <img
            alt="create quiz"
            className={`init-image${classname ? ' image' + classname : ''}`}
            src={icon}
          />
        ) : null}
        {title ? <p className="init-title">{title}</p> : null}
        {subtitle ? <p className="init-subtitle">{subtitle}</p> : null}
        {body}
        {this.state.tabIndex > 0 ? (
          this.state.loading === false ? (
            this.isOnFinalTab() ? (
              <div>
                {this.state.error ? (
                  <p className="os-error-text">
                    You don't have enough questions left for this quiz. Add some
                    topics or
                    <span onClick={() => this.props.changeState('settings')}>
                      {' '}
                      adjust your settings{' '}
                    </span>
                    to review retired questions.
                  </p>
                ) : null}
                {!this.state.error &&
                this.state.tags.length !== 0 &&
                !(
                  this.state.tagQuestionCount >= this.state.count ||
                  this.props.params.fromDash
                ) ? (
                  <p className="os-error-text">{`Your maximum possible quiz size is ${this.state.tagQuestionCount} questions, but your count is ${this.state.count}. You can add topics for a longer quiz or click below to get started.`}</p>
                ) : null}
                <QbankButton
                  style={Object.assign({
                    height: '35px',
                    width: '200px',
                    marginBottom: '200px'
                  })}
                  disabled={
                    this.state.error ||
                    (!this.props.params.fromDash &&
                      this.state.tags.length === 0)
                  }
                  label={
                    this.state.tags.length || this.props.params.fromDash
                      ? (this.state.tagQuestionCount > 0 ||
                          this.props.params.fromDash) &&
                        !this.state.error
                        ? 'SAVE & START QUIZ'
                        : 'SELECT MORE TOPICS'
                      : 'SELECT TOPICS'
                  }
                  onClick={this.handleNew}
                />
                {this.props.params.questions &&
                this.props.params.questions.length &&
                this.props.params.questions.length === 50 ? (
                  <div id="incorrect-quiz-warning">
                    *Quizzing from incorrect will use up to your 50 oldest
                    incorrect questions
                  </div>
                ) : null}
              </div>
            ) : (
              <div>
                {error ? (
                  <p className="os-error-text">
                    There are not enough new questions to create your quiz.{' '}
                    <span
                      onClick={() => {
                        this.props.updateQuiz({
                          updateObject: { error: false }
                        });
                        this.props.changeState('settings');
                      }}
                    >
                      {' '}
                      Turn off spaced repetition{' '}
                    </span>
                    to see all remaining questions.
                  </p>
                ) : null}
                <QbankButton
                  style={styles.nextButton}
                  label="NEXT"
                  onClick={this.handleNext}
                />
              </div>
            )
          ) : (
            <div className="init-spin-wrapper">
              <CircularProgress size={60} thickness={7} color="#95BF5E" />
            </div>
          )
        ) : null}
      </div>
    );
  }

  generateCard(icon, title, subtitle, state, prop, className) {
    return this.state.tabIndex !== 4 ? (
      <div
        onClick={() => this.setState(state)}
        className={`${className ? className + ' ' : ''}init-card${
          this.state[prop] === state[prop] ? ' init-selected' : ''
        }`}
      >
        {icon ? (
          <img alt="select mode" className="init-image mode-image" src={icon} />
        ) : null}
        {title ? <p className="init-card-title">{title}</p> : null}
        {subtitle ? <p className="mode-subtitle">{subtitle}</p> : null}
      </div>
    ) : (
      <div className="select-mode-wrapper">
        <div
          onClick={() => this.setState(state)}
          className={`${className ? className + ' ' : ''}init-card${
            this.state[prop] === state[prop] ? ' init-selected' : ''
          }`}
        >
          {icon ? (
            <img
              alt="select mode"
              className="init-image mode-image"
              src={icon}
            />
          ) : null}
          {title ? <p className="init-card-title">{title}</p> : null}
        </div>
        {subtitle ? <p className="mode-subtitle">{subtitle}</p> : null}
      </div>
    );
  }

  render() {
    const lungs = this.props.product
      ? require(`../images/${ASSET_PREFIX[this.props.product]}-lungs@3x.png`)
      : null;
    const stopwatch = this.props.product
      ? require(`../images/${
          ASSET_PREFIX[this.props.product]
        }-stopwatch@3x.png`)
      : null;
    const book = this.props.product
      ? require(`../images/${ASSET_PREFIX[this.props.product]}-book@3x.png`)
      : null;
    const readyQuiz = this.props.product
      ? require(`../images/${ASSET_PREFIX[this.props.product]}-icons-3@3x.png`)
      : null;
    const questionSquares = this.props.product
      ? require(`../images/${
          ASSET_PREFIX[this.props.product]
        }-question-squares@3x.png`)
      : null;

    const tags = this.sortTags(this.state.organsAlpha, this.props.tags);

    const tabs = [
      [
        readyQuiz,
        "Ready? Let's get started!",
        "Pick your settings for your quiz. Don't worry, you can come back and edit them later, as many times as you like.",
        <div className="init-buttons">
          <QbankButton
            style={styles.quizButton}
            labelColor="#FDFDFD"
            label="START NEW QUIZ"
            disabled={this.state.loading}
            onClick={() => this.setState({ tabIndex: 1 })}
          />
          {(this.props.currentQuiz &&
            typeof this.props.currentQuiz === 'string') ||
          (this.props.currentQuiz &&
            this.props.currentQuiz.questions &&
            this.props.currentQuiz.questions.reduce(
              (acc, q) => (q.answered ? acc + 1 : acc),
              0
            ) !== this.props.currentQuiz.questions.length &&
            !this.props.currentQuiz.viewOnly) ? (
            this.state.loading === false ? (
              <QbankButton
                style={styles.quizButton}
                label="CONTINUE CURRENT QUIZ"
                onClick={this.handleContinue}
              />
            ) : (
              <CircularProgress size={60} thickness={7} color="#95BF5E" />
            )
          ) : null}
        </div>,
        'ready'
      ],
      [
        questionSquares,
        'How many questions would you like to start with?',
        "You'll be able to edit these settings at any time.",
        <div className="count-body">
          <input
            onKeyDown={e =>
              !e.persist() && e.key === 'Enter'
                ? this.setState(
                    Object.assign(
                      { tabIndex: this.state.tabIndex + 1 },
                      this.state.tabIndex === 1 && this.state.count === ''
                        ? { count: 5 }
                        : {}
                    )
                  )
                : null
            }
            className="count-text"
            type="text"
            value={this.state.count}
            onChange={e => {
              const val = parseInt(e.target.value.replace(/\D/g, '')) || '';
              this.setState({ count: val > 300 ? 300 : val });
            }}
            onFocus={() =>
              document.removeEventListener('keydown', this.onKeyDown, false)
            }
            onBlur={() => {
              document.addEventListener('keydown', this.onKeyDown, false);
              this.state.count === '' ? this.setState({ count: 5 }) : null;
            }}
          />
          <div className="slider-row">
            <p>0</p>
            <Slider
              className="count-slider"
              value={this.state.count || 0}
              min={5}
              max={300}
              step={1}
              onChange={count => this.setState({ count })}
            />
            <p>300</p>
          </div>
        </div>,
        'count'
      ],
      [
        null,
        'What are you in the mood for today?',
        null,
        <div className="mode-row">
          {this.generateCard(
            book,
            'STUDY MODE',
            'See answer explanations as you go.',
            { mode: 'practice' },
            'mode'
          )}
          {this.generateCard(
            stopwatch,
            'TEST MODE',
            'See answer explanations after the test.',
            { mode: 'test' },
            'mode',
            'mode-select'
          )}
        </div>
      ],
      [
        null,
        'We can filter our Qbank to match the test you are studying for.',
        'Select the one that fits your study needs.',
        <div className="topic-row">
          {this.generateCard(
            null,
            'SHOW ALL QUESTIONS',
            '',
            { exam: 'all' },
            'exam'
          )}
          {this.props.examTags &&
            this.props.examTags.map(tag =>
              this.generateCard(null, tag.title, '', { exam: tag.id }, 'exam')
            )}
        </div>
      ],
      [
        lungs,
        'Choose your topics or have Hippo give you what you need based on your performance history.',
        null,
        <div className="topic-row">
          {this.generateCard(
            null,
            'CHOOSE TOPICS',
            'Pick the topics you want to focus on for this session.',
            { hippoSelect: false },
            'hippoSelect'
          )}
          {this.generateCard(
            null,
            'HIPPO SELECTED',
            'Let our algorithm prioritize and push questions for topics that you need to improve on the most.',
            { hippoSelect: true },
            'hippoSelect'
          )}
        </div>,
        'topic'
      ],
      [
        null,
        null,
        null,
        <div className="init-organ-systems">
          <p className="init-title">Choose Topics:</p>
          <div className="init-organ-title-row">
            <div className="os-sort-col">
              <div className="organize-selection">
                <div
                  className={`org-select-button org-sort-button${
                    this.state.organsAlpha ? ' sort-selected' : ''
                  }`}
                  style={
                    this.state.organsAlpha
                      ? { color: 'white', backgroundColor: '#A1A0A0' }
                      : {
                          color: '#848484',
                          backgroundColor: 'white'
                        }
                  }
                  onClick={() => this.setState({ organsAlpha: true })}
                >
                  <span>ALPHABETICAL</span>
                </div>
                <div
                  className={`org-select-button org-sort-button${
                    !this.state.organsAlpha ? ' sort-selected' : ''
                  }`}
                  style={
                    !this.state.organsAlpha
                      ? { color: 'white', backgroundColor: '#A1A0A0' }
                      : {
                          color: '#848484',
                          backgroundColor: 'white'
                        }
                  }
                  onClick={() => this.setState({ organsAlpha: false })}
                >
                  <span>WEAK TO STRONG</span>
                </div>
              </div>
            </div>
            <div
              className={`select-all${
                this.state.tags.length === this.props.tags.length
                  ? ' all-selected'
                  : ''
              }`}
              onClick={this.toggleAllTags}
            >
              <p>{`${
                this.state.tags.length === this.props.tags.length ? 'DE' : ''
              }SELECT ALL`}</p>
            </div>
          </div>
          <div className="init-organ-list">
            <Shuffle duration={500}>
              {tags && tags.map
                ? tags.map((tag, i) => {
                    const percent = isNaN(
                      tag.accountCorrectCount / tag.accountTotalCount
                    )
                      ? 0
                      : Math.floor(
                          (tag.accountCorrectCount / tag.accountTotalCount) *
                            100
                        );
                    return (
                      <div
                        key={tag.id}
                        onClick={() => {
                          const tags = _.cloneDeep(this.state.tags);
                          _.includes(tags, i)
                            ? tags.splice(tags.indexOf(i), 1)
                            : tags.push(i);
                          this.setState({
                            tags,
                            error: false,
                            tagQuestionCount: this.props.tags
                              .filter((tag, i) => _.includes(tags, i))
                              .reduce((sum, tag) => sum + tag.questionCount, 0)
                          });
                        }}
                        className={`init-organ-card${
                          _.includes(this.state.tags, i)
                            ? ' init-organ-selected'
                            : ''
                        }`}
                      >
                        <div className="init-organ-image-frame">
                          <img
                            alt="organ tag"
                            className="init-organ-image"
                            src={tag.imageUrl || placeholder}
                          />
                        </div>
                        <div className="init-organ-progress">
                          <Line
                            percent={percent * 0.85}
                            className="init-organ-bar"
                            strokeWidth="13"
                            trailWidth="13"
                            style={{
                              width: '85%'
                            }}
                            strokeColor={
                              percent < 71
                                ? '#FF7065'
                                : percent < 86
                                ? '#DFDF56'
                                : '#95BF5E'
                            }
                          />
                          <p className="init-organ-percent">{`${percent}%`}</p>
                        </div>
                        <p className="init-organ-title">{tag.title}</p>
                      </div>
                    );
                  })
                : null}
            </Shuffle>
          </div>
        </div>,
        'organs'
      ]
    ];

    return (
      <div className="init">
        <div className="center-content-horizontal">
          {this.props.isTrial ? (
            <div className="trial-init">
              <img alt="" className="trial-img" src={readyQuiz} />
              <p className="init-title">
                Ready to try 10 questions? Get Started!
              </p>
              <p className="init-subtitle">
                You can upgrade to the full version any time you like!
              </p>
              {this.state.loading ? (
                <div className="init-spin-wrapper">
                  <CircularProgress size={60} thickness={7} color="#95BF5E" />
                </div>
              ) : (
                <QbankButton
                  height="50px"
                  width="280px"
                  onClick={() => this.initTrial()}
                  label="START FREE TRIAL"
                />
              )}
            </div>
          ) : (
            <div>
              <div
                className={`${
                  this.state.tabIndex === 0 ? 'hide-on-mobile  ' : ''
                }init-top-row`}
              >
                <p className="hide hide-on-mobile">
                  <img alt="" src={cross} />
                </p>
                <p className="init-heading">QUIZ SETUP</p>
                <p
                  onClick={() =>
                    this.setState({
                      count: 5,
                      mode: 'practice',
                      tags: [],
                      tabIndex: 0
                    })
                  }
                  className={
                    this.state.tabIndex === 0 || this.props.params.intro
                      ? 'hide hide-on-mobile'
                      : 'return-to-start hide-on-mobile'
                  }
                >
                  <img alt="" src={cross} />
                </p>
              </div>
              <hr
                className={`${
                  this.state.tabIndex === 0 ? 'hide-on-mobile  ' : ''
                }init-break${
                  this.state.tabIndex > 2 && this.state.tabIndex < 4
                    ? ' alt-break'
                    : ''
                }`}
              />
              {this.generateTab(...tabs[this.state.tabIndex])}
            </div>
          )}
        </div>
        <div
          style={this.state.tabIndex !== 0 ? { display: 'none' } : {}}
          className="android-app"
        >
          <div className="get-the-mobile-app">GET THE MOBILE APP</div>
          <a
            href={`https://play.google.com/store/apps/details?id=com.hippo.mobile.qbank.${ASSET_PREFIX[
              this.props.product
            ].toLowerCase()}&hl=en`}
          >
            <img src="https://i.imgur.com/YvIi0AK.png" />
          </a>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const currentQuiz = state.app ? state.app.currentQuiz : null;
  const isTrial = state.app && state.app.user ? state.app.user.isTrial : null;
  return {
    product: state.app.product,
    currentQuiz,
    isTrial,
    tags: state.tags || [],
    examTags: state.examTags || [],
    quiz: state.quiz
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      updateApp,
      updateQuiz,
      changeState,
      continueQuiz,
      createQuiz,
      updateDashboard,
      updateSettings
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Init);



// WEBPACK FOOTER //
// ./src/containers/Init.js